<template>
  <div style="position: relative;">
    <v-data-table :headers="headers" :items="templates" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="items" slot-scope="props">
        <td @click.stop="open_edit_channel_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.title }}</td>
        <td @click.stop="open_edit_channel_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.name }}</td>
        <td @click.stop="open_edit_channel_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.uuid }}</td>
        <td @click.stop="open_edit_channel_group(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.state }}</td>
      </template>
    </v-data-table>
    <v-btn class="deep-orange" v-if="$is_admin()" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add_channel_group"><v-icon>add</v-icon></v-btn>

    <v-toolbar :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; width: 300px;">
      <v-text-field color="deep-orange" v-model="search_text" ref="search_field" prepend-icon="search" hide-details single-line></v-text-field>
    </v-toolbar>

    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import BottomSheet from '../BottomSheet'

export default {
  components: {
    BottomSheet
  },
  data () {
    return {
      headers: [
        { text: 'Title', value: 'title', align: 'left' },
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Uuid', value: 'uuid', align: 'left' },
        { text: 'State', value: 'state', align: 'left', sortable: false }
      ],
      pagination: {
        sortBy: 'title',
        descending: true,
        rowsPerPage: 25
      },
      search_text: "",
      state_filters: ['active']
    }
  },
  computed: {
    templates () {
      var ret = _.values(this.$store.state.channel_templates);
      var self = this;
      var search = (this.search_text || "").toLowerCase();
      if (search.length > 0) {
        ret = _.filter(ret, function(template) {
          ret = false;
          if (template.title.toLowerCase().includes(search)) ret = true;
          if (template.name.toLowerCase().includes(search)) ret = true;
          if (template.uuid.toLowerCase().includes(search)) ret = true;
          return ret;
        })
      }
      return ret;
    }
  },
  methods: {
    if_archived_color(state) {
      return state == 'archived' ? this.$dark() ? 'grey darken-2 grey--text' : 'grey lighten-4' : ''
    },
    open_edit_channel_group(uuid) {
      if (!this.$is_admin()) {
        return;
      }
      this.$router.push("/channels/configuration_presets/edit/"+uuid)
    },
    open_add_channel_group() {
      if (!this.$is_admin()) {
        return;
      }
      this.$router.push("/channels/configuration_presets/new")
    }
  }
}
</script>